import { render, staticRenderFns } from "./ActivityFormModalNew.vue?vue&type=template&id=2126a743&scoped=true"
import script from "./ActivityFormModalNew.vue?vue&type=script&lang=ts"
export * from "./ActivityFormModalNew.vue?vue&type=script&lang=ts"
import style0 from "./ActivityFormModalNew.vue?vue&type=style&index=0&id=2126a743&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126a743",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2126a743')) {
      api.createRecord('2126a743', component.options)
    } else {
      api.reload('2126a743', component.options)
    }
    module.hot.accept("./ActivityFormModalNew.vue?vue&type=template&id=2126a743&scoped=true", function () {
      api.rerender('2126a743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ActivityFormModalNew.vue"
export default component.exports